(() => {
  const ready = (fn) => document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn();
  ready(() => {
    document.documentElement.classList.add('la-js');

    const header = document.querySelector('[data-amx-header]');
    const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 32);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });

    document.querySelectorAll('[data-couture-hero]').forEach(hero => {
      const slides = [...hero.querySelectorAll('[data-hero-slide]')];
      const dots = [...hero.querySelectorAll('[data-hero-dot]')];
      let current = 0;
      let timer;
      const duration = 6500;
      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((s, i) => s.classList.toggle('is-active', i === current));
        dots.forEach((d, i) => d.classList.toggle('is-active', i === current));
        clearTimeout(timer);
        if (slides.length > 1) timer = setTimeout(() => show(current + 1), duration);
      };
      dots.forEach(dot => dot.addEventListener('click', () => show(Number(dot.dataset.index))));
      show(0);
    });

    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.la-reveal').forEach(el => io.observe(el));

    const parallaxEls = [...document.querySelectorAll('[data-parallax-media]')];
    let ticking = false;
    const parallax = () => {
      const vh = window.innerHeight;
      parallaxEls.forEach(el => {
        const r = el.getBoundingClientRect();
        if (r.bottom > 0 && r.top < vh) {
          const p = (r.top + r.height / 2 - vh / 2) / vh;
          el.style.setProperty('--la-parallax', `${Math.max(-1, Math.min(1, p)) * -24}px`);
        }
      });
      ticking = false;
    };
    window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(parallax); ticking = true; } }, { passive: true });
    parallax();

    document.querySelectorAll('[data-product-rail]').forEach(rail => {
      const track = rail.querySelector('[data-rail-track]');
      const amount = () => Math.max(320, track.clientWidth * .72);
      rail.querySelector('[data-rail-prev]')?.addEventListener('click', () => track.scrollBy({ left: -amount(), behavior: 'smooth' }));
      rail.querySelector('[data-rail-next]')?.addEventListener('click', () => track.scrollBy({ left: amount(), behavior: 'smooth' }));
    });
  });
})();

// v4.16 header / mobile drawer interactions
(function(){
  function initAmxChrome(){
    var header=document.querySelector('[data-amx-header]');
    var drawer=document.getElementById('mobileMenu');
    var toggle=document.getElementById('menuToggle');

    if(header && !header.dataset.scrollBound){
      header.dataset.scrollBound='true';
      var onScroll=function(){ header.classList.toggle('is-scrolled', window.scrollY>24); };
      onScroll();
      window.addEventListener('scroll',onScroll,{passive:true});
    }

    if(!drawer || !toggle) return;

    /* Shopify can re-render sections in the theme editor. Mark a bound pair so
       we don't stack duplicate listeners on ordinary page loads. */
    if(toggle.dataset.drawerBound==='true') return;
    toggle.dataset.drawerBound='true';

    var backdrop=drawer.querySelector('.amx-drawer__backdrop');
    var close=drawer.querySelector('.amx-drawer__close');
    var focusableSelector='a[href],button:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';
    var previousFocus=null;

    function setOpen(open){
      drawer.classList.toggle('is-open',open);
      drawer.setAttribute('aria-hidden',open?'false':'true');
      toggle.setAttribute('aria-expanded',open?'true':'false');
      toggle.setAttribute('aria-label',open?'Close menu':'Open menu');
      document.documentElement.classList.toggle('la-mobile-menu-open',open);

      if(open){
        previousFocus=document.activeElement;
        window.requestAnimationFrame(function(){
          var target=drawer.querySelector('.amx-drawer__close') || drawer.querySelector(focusableSelector);
          if(target) target.focus({preventScroll:true});
        });
      }else if(previousFocus && typeof previousFocus.focus==='function'){
        previousFocus.focus({preventScroll:true});
      }
    }

    function openDrawer(e){ if(e) e.preventDefault(); setOpen(true); }
    function closeDrawer(e){ if(e) e.preventDefault(); setOpen(false); }

    toggle.addEventListener('click',function(e){
      e.preventDefault();
      e.stopPropagation();
      setOpen(!drawer.classList.contains('is-open'));
    });
    if(backdrop) backdrop.addEventListener('click',closeDrawer);
    if(close) close.addEventListener('click',closeDrawer);

    drawer.addEventListener('click',function(e){
      var link=e.target.closest('a[href]');
      if(link) closeDrawer();
    });

    document.addEventListener('keydown',function(e){
      if(e.key==='Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initAmxChrome);
  else initAmxChrome();

  document.addEventListener('shopify:section:load',function(){
    /* Re-rendered header receives a fresh button, so init will bind it. */
    initAmxChrome();
  });
})();
